import { render } from "./SubNav.vue?vue&type=template&id=24336a82&scoped=true"
import script from "./SubNav.vue?vue&type=script&lang=js"
export * from "./SubNav.vue?vue&type=script&lang=js"

import "./SubNav.vue?vue&type=style&index=0&id=24336a82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24336a82"

export default script